import { MatchDayResultsModel } from './../models/MatchDayResultsModel';
import { GetterTree } from 'vuex';
import { LeagueState, Settings, LeagueTableState, LeagueTableViewItem, NextMatchWidgetState, Season, NextMatchWidgetModel, LastMatchWidgetState, LastMatchWidgetModel } from './models';
import { RootState } from '@/store';
import { LastMatchDayResultsWidgetState } from '../models/LastMatchDayResultsWidgetModel';

export enum Getters {
    SETTINGS = 'SETTINGS',
    LOADED = 'LOADED',
    ACTIVE_SEASON_ID = 'ACTIVE_SEASON_ID',
    SEASON_FULL_NAME = 'SEASON_FULL_NAME',
    ACTIVE_SEASON = 'ACTIVE_SEASON',
    LEAGUE_TABLE_STATE = 'LEAGUE_TABLE_STATE',
    NEXT_MATCH_WIDGET_STATE = 'NEXT_MATCH_WIDGET_STATE',
    NEXT_MATCH = 'NEXT_MATCH',
    LAST_MATCH_WIDGET_STATE = 'LAST_MATCH_WIDGET_STATE',
    LAST_MATCH = 'LAST_MATCH',
    LAST_MATCH_DAY_RESULTS_WIDGET_STATE = 'LAST_MATCH_DAY_RESULTS_WIDGET_STATE',
    LAST_MATCH_DAY_RESULTS = 'LAST_MATCH_DAY_RESULTS',
  }

export const getters: GetterTree<LeagueState, RootState> = {
  [Getters.SETTINGS]({ settings }): Settings | undefined {
    return settings;
  },
  [Getters.LOADED]({ loaded }): boolean {
    return loaded;
  },
  [Getters.ACTIVE_SEASON]({ settings }): Season | undefined {
    return  settings ? settings.activeSeason : undefined;
  },
  [Getters.ACTIVE_SEASON_ID]({ settings }): number | undefined {
    if (!settings || !settings.activeSeason) {
      return undefined;
     // throw new Error('League settings is undefined');
    }
    return settings.activeSeason.id;
  },
  [Getters.SEASON_FULL_NAME]({ settings }): string {
    if (!settings || !settings.activeSeason) {
      return '';
    }
    return `${settings.activeSeason.description} - ${settings.activeSeason.name}`;
  },

  [Getters.LEAGUE_TABLE_STATE]({ leagueTable }): LeagueTableState {
    return leagueTable;
  },

  [Getters.NEXT_MATCH_WIDGET_STATE]({ nextMatchWidget }): NextMatchWidgetState {
    return nextMatchWidget;
  },
  [Getters.NEXT_MATCH]({ nextMatchWidget }): NextMatchWidgetModel | undefined {
    return nextMatchWidget.nextMatch;
  },

  [Getters.LAST_MATCH_WIDGET_STATE]({ lastMatchWidget }): LastMatchWidgetState {
    return lastMatchWidget;
  },
  [Getters.LAST_MATCH]({ lastMatchWidget }): LastMatchWidgetModel | undefined {
    return lastMatchWidget.lastMatch;
  },
  [Getters.LAST_MATCH_DAY_RESULTS_WIDGET_STATE]({ lastMatchDayResultsWidget }): LastMatchDayResultsWidgetState {
    return lastMatchDayResultsWidget;
  },

  [Getters.LAST_MATCH_DAY_RESULTS]({ lastMatchDayResultsWidget }): MatchDayResultsModel {
    return lastMatchDayResultsWidget.lastMatchDayResults;
  },
};
